export function optionalProperty<T extends string, U>(key: T, value: U | undefined | null): Record<T, U> | {} {
  if (value === undefined || value === null || (Array.isArray(value) && value.length === 0) || Number.isNaN(value))
    return {};
  return { [key]: value };
}
